export { SpaTreatmentFacilityBookingContent } from './SpaTreatmentFacilityBookingContent';
export type {
  SpaGuestConfig,
  SpaTreatmentFacilityBookingContentLabels,
  SpaTreatmentFacilityBookingContentProps,
} from './SpaTreatmentFacilityBookingContent.types';
